<template>
    <div style="margin-top: 5px;">
        <!-- 轮播图 -->
        <el-carousel :interval="4000" type="card" height="250px">
            <el-carousel-item v-for="p in obj" :key="p.id">
            <!-- <h3 class="medium">{{ item }}</h3> -->
                <div style="">
                    <img width="100%" :src="p.pho" alt="">
                </div>
            </el-carousel-item>
        </el-carousel> 
        <!-- <el-carousel style="height: 600px;" indicator-position="outside">
            <el-carousel-item style="height: 600px;" v-for="item,index in obj" :key="index">
                <img width="100%"  :src="item.pho" alt="">
            </el-carousel-item>
        </el-carousel> -->

        <main>
            <div class="album py-5 bg-light">
                <img style="margin-left: 87px; margin-bottom: 20px;" src="../assets/KeCheng/title-bg3.png" alt="">
                <div class="container">
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">

                        <div class="col" v-for="(p,index) in courseList" :key="index">
                            <div class="card shadow-sm">
                                <div>
                                    <img class="img-fluid"  width="428px"  :src="p.photo" alt="这是课程图片">
                                </div>
                                <div class="card-body">
                                    <div class="card-text" style="font-size: 12px;">
                                        <!-- 这里是商品描述 -->
                                    <!-- 课程介绍和课程价格 -->
                                        <div style="background-color: white;">
                                            <div style="font-size: 18px; color:#545C63">
                                                {{ p.courseName }}
                                            </div>
                                            <div style="padding:10px 10px 10px 0px; font-size: 16px; color:#9199A1">
                                                <p>报名人数：{{ p.participants }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px;" @click="ClickMeGoClass(p)">查看</button>
                                            <!-- <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px;">收藏</button> -->
                                        </div>
                                        <small class="text-muted"> 
                                            <span style="color:red; font-size: 14px;">￥ {{ p.price }}&nbsp;&nbsp;&nbsp;</span>
                                            <span style="text-decoration: line-through; font-size: 14px;">￥ {{ parseInt(p.price * 1.5) }}</span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name:'functions',
        data() {
            return {
                photo:[
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a11.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a2.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a3.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a4.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a5.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a6.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a7.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a8.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a9.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a10.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a1.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a12.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a13.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a14.jpg')},
                    {name:'C++语法基础课', pho:require('../assets/KeCheng/a15.jpg')},
                ],
                obj: [
                    {pho:require('../assets/image/Light-img/3123.png'), id:'001'},
                    {pho:require('../assets/image/Light-img/3412.jpg'), id:'002'},
                    {pho:require('../assets/KeCheng/courseImage/xuezijiangtang.png'), id:'003'},
                    // {pho:require('../assets/image/1.jpg'), id:'003'},
                    // {pho:require('../assets/image/5.jpg'), id:'004'},
                    // {pho:require('../assets/image/2.jpg'), id:'005'},
                    // {pho:require('../assets/image/3.jpg'), id:'006'},
                ],
                courseList:[],
            }
        },
        methods: {
            ClickMeGoClass(p) {
                this.$router.push({
                    name:'programmes',
                    params: {
                        id:p.id
                    }
                })
            }
        },
        beforeCreate() {
            const vue = this
            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/course/read/list/',
                type:'get',
                success(resp) {
                    if (resp.error_message === 'success') {
                        console.log("课程接受成功了")
                        vue.courseList = JSON.parse(resp.courseList)
                        console.log(vue.courseList)
                    }
                },
                error(resp) {
                    console.log("课程接受彻底失败了, resp == >", resp)
                }
            })
        }
    }
</script>

<style scoped>  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.b-example-divider {
  height: 3rem;
  background-color: rgba(0, 0, 0, .1);
  border: solid rgba(0, 0, 0, .15);
  border-width: 1px 0;
  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.b-example-vr {
  flex-shrink: 0;
  width: 1.5rem;
  height: 100vh;
}

.bi {
  vertical-align: -.125em;
  fill: currentColor;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

/* ^ */
.ClassFunction {
    width: 90%; 
    height: auto;
    /* background-color: white;  */
    display: flex; 
    flex-direction:row;
    /* margin: 0 auto; */
    margin-left: 5%;
    margin-top: 10px;
}
.image {
    width: 100%;
    border-radius: 7px; 
}
.Functions {
    margin-top: 10px;
    width: 24.25%;
    position: relative;
    transition: top 0.5s ease;
    box-shadow: 8px 14px 14px rgba(2, 235, 251, 0.12), 0 0 6px rgba(0, 0, 0, .04);
}
.Functions:hover {
    top: -3px
}
/* v */

/* ^ */
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
/*  */
</style>